/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestDeleteUserRequest
 */
export interface RequestDeleteUserRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteUserRequest
     */
    baseId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteUserRequest
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteUserRequest
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteUserRequest
     */
    updatedUserId?: number;
}

/**
 * Check if a given object implements the RequestDeleteUserRequest interface.
 */
export function instanceOfRequestDeleteUserRequest(value: object): value is RequestDeleteUserRequest {
    return true;
}

export function RequestDeleteUserRequestFromJSON(json: any): RequestDeleteUserRequest {
    return RequestDeleteUserRequestFromJSONTyped(json, false);
}

export function RequestDeleteUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestDeleteUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'updatedUserId': json['updated_user_id'] == null ? undefined : json['updated_user_id'],
    };
}

export function RequestDeleteUserRequestToJSON(json: any): RequestDeleteUserRequest {
    return RequestDeleteUserRequestToJSONTyped(json, false);
}

export function RequestDeleteUserRequestToJSONTyped(value?: RequestDeleteUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'id': value['id'],
        'tenant_id': value['tenantId'],
        'updated_user_id': value['updatedUserId'],
    };
}

